import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { ListItemIcon, Menu, Typography } from "@mui/material";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled";
import type { MeasureSubgroup } from "../../../../../../../../../api/types/svTypes.ts";

export interface MeasureGroupOptionsTarget {
  group: string;
  subgroup?: MeasureSubgroup;
}

interface Props extends MeasureGroupOptionsTarget {
  x: number;
  y: number;
  onCreateSubgroup: (group: string) => void;
  onEditSubgroup: (subgroup: MeasureSubgroup) => void;
  onDeleteSubgroup: (subgroup: MeasureSubgroup) => void;
  onClose: () => void;
}

const MeasureGroupMenu = ({
  x,
  y,
  group,
  subgroup,
  onCreateSubgroup,
  onEditSubgroup,
  onDeleteSubgroup,
  onClose,
}: Props) => (
  <Menu
    open
    anchorReference="anchorPosition"
    anchorPosition={{ top: y + 15, left: x }}
    onClose={onClose}
    slotProps={{ paper: { sx: { width: 200 } } }}
  >
    {subgroup === undefined && (
      <MenuItemStyled onClick={() => onCreateSubgroup(group)}>
        <ListItemIcon sx={{ color: "secondary.main" }}>
          <CreateNewFolderOutlinedIcon />
        </ListItemIcon>
        <Typography>Create Subgroup</Typography>
      </MenuItemStyled>
    )}
    {subgroup !== undefined && (
      <MenuItemStyled onClick={() => onEditSubgroup(subgroup)}>
        <ListItemIcon sx={{ color: "secondary.main" }}>
          <EditOutlinedIcon />
        </ListItemIcon>
        <Typography>Edit Subgroup</Typography>
      </MenuItemStyled>
    )}
    {subgroup !== undefined && (
      <MenuItemStyled onClick={() => onDeleteSubgroup(subgroup)}>
        <ListItemIcon sx={{ color: "error.main" }}>
          <DeleteOutlineIcon />
        </ListItemIcon>
        <Typography>Delete</Typography>
      </MenuItemStyled>
    )}
  </Menu>
);

export default MeasureGroupMenu;
